import {combineReducers} from 'redux';
import checkout from './checkout/checkout-reducer';
import city from './city/city-reducer';
import destination from './destination/destination-reducer';
import event from './event/event-reducer';
import eventPackage from './event-package/event-package-reducer';
import filters from './filters/filters-reducer';
import notification from './notification/notification-reducer';
import search from './search/search-reducer';
import searchRequest from './search-request/search-request-reducer';
import spot from './spot/spot-reducer';
import spots from './spots/spots-reducer';
import user from './user/user-reducer';
import category from './category/category-reducer';
import page from './page/page-reducer';
import cms from './cms/cms-reducer';
import dynamicRates from './dynamic-rates/dynamic-rates-reducer';
import midfunnel from './midfunnel/midfunnel-reducer';
import appRating from './app-rating/app-rating-reducer';
import jobs from './jobs/jobs-reducer';

export default combineReducers({
    category,
    checkout,
    city,
    destination,
    dynamicRates,
    event,
    eventPackage,
    filters,
    notification,
    search,
    searchRequest,
    spot,
    spots,
    user,
    page,
    cms,
    midfunnel,
    appRating,
    jobs,
});
